import {ButtonDropdown, DropdownHandler, EMPHASIS} from '@forecast-it/design-system';
import type {DashboardDateField} from '../hooks/useDashboardFilters';

const DATE_FIELD_OPTIONS: {value: DashboardDateField; label: string}[] = [
	{value: 'created_at', label: 'Created date'},
	{value: 'last_activity_at', label: 'Last activity'},
	{value: 'resolved_at', label: 'Resolved date'},
];

interface Props {
	value: DashboardDateField;
	onChange: (field: DashboardDateField) => void;
}

export function DateFieldSelect({value, onChange}: Props) {
	const selected = DATE_FIELD_OPTIONS.find(o => o.value === value);

	return (
		<DropdownHandler>
			<DropdownHandler.Trigger>
				<ButtonDropdown emphasis={EMPHASIS.LOW} data-cy="dashboard-date-field">
					{selected?.label ?? 'Created date'}
				</ButtonDropdown>
			</DropdownHandler.Trigger>
			<DropdownHandler.Content offset={4}>
				{DATE_FIELD_OPTIONS.map(option => (
					<DropdownHandler.Item key={option.value} onClick={() => onChange(option.value)}>
						{option.label}
					</DropdownHandler.Item>
				))}
			</DropdownHandler.Content>
		</DropdownHandler>
	);
}
